import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { ILeftNav, ILeftNavClickEvent, ILeftNavItem, IToastEvent, LeftNavComponent, IconComponent, AvatarComponent } from '@sarasanalytics-com/design-system';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StoreService } from 'src/app/services/store/store.service';
import { Products } from 'src/app/interfaces/state-interface';
import { AppService } from 'src/app/services/app.service';
import { IToast } from 'src/app/interfaces/toast-interface';
import { ToastComponent } from '@sarasanalytics-com/design-system';
import { CookiesService } from 'src/app/services/cookies/cookies.service';
import { NS_Enums } from 'src/app/static/namespace';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    LeftNavComponent,
    ToastComponent,
    IconComponent,
    AvatarComponent
],
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  readonly dialog = inject(MatDialog);
  router = inject(Router);
  route = inject(ActivatedRoute);
  logoutDialogRef: MatDialogRef<any>;
  @ViewChild('logoutButton') logoutButton: TemplateRef<any>;
  @ViewChild('leftnavTemp') leftnavTemp: LeftNavComponent;

  private authService: AuthService = inject(AuthService);
  private store: StoreService = inject(StoreService);
  private appService: AppService = inject(AppService);
  private cookieService: CookiesService = inject(CookiesService);
  
  private toastInterval: any;
  private toastTimeout: any;
  user: any
  avatarNavItem: ILeftNavItem = {
    title: 'Name',
    disable: false,
    tooltip: '',
    type: 'AVATAR',
    altText: '',
    active: false,
  };

  toast: IToast | null;

  data: ILeftNav = {
    logo: {
      "icon": "sarasWhite",
      "iconSize": "40",
      "title": "Saras",
      "altText": "Saras",
      "tooltip": "Saras"
    },
    items: [
      {
        title: 'Home',
        icon: 'home_icon',
        disable: false,
        tooltip: 'Home',
        relativePath: true,
        path: 'products',
        iconLabel: "Home"
      },
      {
        title: 'Setup MFA',
        icon: 'shield',
        disable: false,
        tooltip: 'Setup MFA',
        relativePath: true,
        path: 'configure-mfa',
        iconLabel: "Setup MFA"
      }
    ],
    footerItems: [
      this.avatarNavItem
    ],
  };

  constructor() {
    const saras_global = this.cookieService.get(NS_Enums.saras_global) || null;
    if(this.authService.isLoggedIn && !saras_global){
      this.authService.logOut();
    }
    this.store.setProduct(Products.SARAS);
    this.appService.setProductType(Products.SARAS);
  }

  ngOnInit() {
    this.router.initialNavigation();
    const userDetail: any = this.getUserDetail()

    this.appService.toastEvent$.subscribe((toast) => {
      if(toast){
        this.toast = toast;
        this.toastInterval = setInterval(()=>{
          if(this.toast){
            const tempFinishPercentage = (this.toast?.finishPercentage || 0) + 1;
            this.toast.finishPercentage = (tempFinishPercentage >= 100) ? 100 : tempFinishPercentage;
          }
        }, 50);
        this.toastTimeout = setTimeout(() => {
          this.onToastClosed();
        }, 6000);
      }
    })

    if(userDetail){
      console.log(userDetail.email);
      this.avatarNavItem.tooltip = userDetail.email;
    }
  }

  ngAfterViewInit() {
    const path: string[] = this.router.url.split('/').filter((p)=> p !== '');
    if(!!path?.length){
      const index = this.data.items?.findIndex((item)=> item.path === path[0]);
      if(index !== undefined && index >= 0){
        this.leftnavTemp.setItemActive(index);
      }
    }else{
      /* If current path is '/' then navigate to first item from list of navitems 'data' that has path */
      let navItemIndex=-1;
      const navItem = this.data.items?.find((item, index)=> {
        navItemIndex = index;
        return !!item.path;
      });
      if(navItem?.path && navItemIndex>=0){
        this.leftnavTemp.setItemActive(navItemIndex);
        this.router.navigate([navItem.path]);
      }
    }
  }

  onToastEvents(event: IToastEvent){
    if(event.type = "TOAST_CLOSED"){
      this.onToastClosed();
    }
  }

  onToastClosed(){
    this.toast = null;
    clearInterval(this.toastInterval);
    clearTimeout(this.toastTimeout);
    this.appService.toastEvent$.next(null);
  }

  getUserDetail() {
    try {
      const user: any = this.store.getUser();
      this.user = user;

      if (user?.firstName && user?.lastName) {
        const firstInitial = user.firstName.charAt(0).toUpperCase();
        const lastInitial = user.lastName.charAt(0).toUpperCase();
        this.avatarNavItem.altText = `${firstInitial}${lastInitial}`;
      }

      return this.user;
    } catch (error) {
      console.error('Error while get user data:', error);
    }
  }

  leftNavEvent(props: ILeftNavClickEvent) {
    if (props.type === 'FOOTER_ITEM_CLICK') {
      if (props.item?.type === 'AVATAR') {
        const position = {
          left:
            16 +
            props.event.target.offsetWidth +
            props.event.target.offsetLeft +
            'px',
          top: props.event.target.offsetTop - 8 + 'px',
        };

        this.avatarNavItem.active = true;

        this.logoutDialogRef = this.dialog.open(this.logoutButton, {
          width: '70px',
          hasBackdrop: true,
          position,
        });
        this.logoutDialogRef.afterClosed().subscribe((v) => {
          this.avatarNavItem.active = false;
        });
      }
    }
  }

  logoutButtonClick() {
    this.authService.logOut();
    if (this.logoutDialogRef) {
      this.logoutDialogRef.close();
    }
  }

  mobileLogoutClick(event: MouseEvent) {
    const position = {
      right: '20px',
      top: '50px',
    };
    
    this.avatarNavItem.active = true;
    this.logoutDialogRef = this.dialog.open(this.logoutButton, {
      width: '280px',
      hasBackdrop: true,
      position,
    });
    this.logoutDialogRef.afterClosed().subscribe(() => {
      this.avatarNavItem.active = false;
    });
  }
}
